// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"9":"2d33710c","56":"2d33710c","585":"2d33710c"}[chunkId] + ".chunk.css";
};